// extracted by mini-css-extract-plugin
export var container = "menu-module--container--2adf9";
export var detail_item = "menu-module--detail_item--c6db3";
export var nav_detail = "menu-module--nav_detail--0bffc";
export var wrapper = "menu-module--wrapper--097d0";